import logo from '../logo.svg';
import '../../src/App.css';
import FormWrapper from './formWrapper.js';

function Home() {
  return (
     <div>
        <img src={logo} className="App-logo" alt="logo" />
        <FormWrapper></FormWrapper>
      </div>
  );
}

export default Home;
